
import axios from "axios";
export default {
  props: [],
  data() {
    return {
        state: false,
        isShowAll: true,
        isShow: false,
        activeNames: [],
        legEndList: [],
        TULIactiveNames: [],
    }
  },
  mounted() {   
    
  },
  methods: {  
    changeState(state) {
      this.state = state
    },  
    toggleAll() {
      this.isShowAll = !this.isShowAll
    },
    toggle(i) {
      this.$set(this.legEndList[i], 'isShow', !this.legEndList[i]['isShow'])
    },
    showPop(checkedVals) {
      this.isShow = true
      this.getGeoLendge(checkedVals) 
    },
    
    closePop() {
      this.isShow = false
    },
    deepClone(obj) {
      let objClone = Array.isArray(obj) ? [] : {};
      if (obj && typeof obj === "object") {
        for (let key in obj) {
          if (obj[key] && typeof obj[key] === "object") {
            objClone[key] = this.deepClone(obj[key]);
          } else {
            objClone[key] = obj[key];
          }
        }
      }
      return objClone;
    },

    async getGeoLendge(codes=[]) {
      // if (codes.findIndex( item => item.key == 'buildings') == -1) {
      //   codes.unshift({key: 'buildings', label: '产业楼栋'})
      // }  
        // 计划立项：jhlx
        // 专项规划：zxgh
        // 实施主体：sszt 使用 
        // 城市更新图例         
      let codesc = this.deepClone(codes)
      if (codesc.findIndex( item => item.keyName == 'zxgh') > -1) {   
         let i = codesc.findIndex( item => item.keyName == 'zxgh')  
         codesc[i].keyName = 'szcsgxlxsj1227'
      } 
      if ( codesc.findIndex( item => item.keyName == 'sszt') > -1  ) {
         let i = codesc.findIndex( item => item.keyName == 'sszt')
         codesc[i].keyName = 'szcsgxlxsj1227'
      }

      if ( codesc.findIndex( item => item.keyName == 'jhlx') > -1 ) {
        let i = codesc.findIndex( item => item.keyName == 'jhlx')
        codesc[i].keyName = 'szcsgxlxsj1227'
      } 


      if (codesc.findIndex( item => item.keyName == 'lytdzbpfgg') > -1) {   
         let i = codesc.findIndex( item => item.keyName == 'lytdzbpfgg')  
         codesc[i].keyName = 'tdzb'
      } 
      if ( codesc.findIndex( item => item.keyName == 'yghcags') > -1  ) {
         let i = codesc.findIndex( item => item.keyName == 'yghcags')
         codesc[i].keyName = 'tdzb'
      }

      if ( codesc.findIndex( item => item.keyName == 'ygbghtg') > -1 ) {
        let i = codesc.findIndex( item => item.keyName == 'ygbghtg')
        codesc[i].keyName = 'tdzb'
      } 

      if ( codesc.findIndex( item => item.keyName == 'ynrzbjhjd') > -1 ) {
        let i = codesc.findIndex( item => item.keyName == 'ynrzbjhjd')
        codesc[i].keyName = 'tdzb'
      } 

      if ( codesc.findIndex( item => item.keyName == 'yghgg') > -1 ) {
        let i = codesc.findIndex( item => item.keyName == 'yghgg')
        codesc[i].keyName = 'tdzb'
      }

      if ( codesc.findIndex( item => item.keyName == 'ybqbcazxyxynrgs') > -1 ) {
        let i = codesc.findIndex( item => item.keyName == 'ybqbcazxyxynrgs')
        codesc[i].keyName = 'tdzb'
      }

      if ( codesc.findIndex( item => item.keyName == 'yssfagg')> -1 ) {
        let i = codesc.findIndex( item => item.keyName == 'ybqbcazxyxynrgs')
        codesc[i].keyName = 'tdzb'
      }

      if ( codesc.findIndex( item => item.keyName == 'qt')> -1 ) {
        let i = codesc.findIndex( item => item.keyName == 'qt')
        codesc[i].keyName = 'tdzb'
      }

      let arr = await Promise.all(codesc.map( async item => {
          return axios.get( `https://cyy.pcmxj.com/arcgis_server/arcgis/rest/services/${item.keyName}/MapServer/legend?f=pjson` )
      })
      )      
      if (arr.length > 0) {
        this.legEndList = arr.map( (item,i) => {
          return {
            title: codes[i].label,
            isShow: true,
            children: item.data.layers ? item.data.layers[0].legend : []
          }
        })
      } else {
        this.legEndList = arr
      }
      
    }
  }
}
